var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpiderweb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_3728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.25C9.25 3.91848 9.1183 3.60054 8.88388 3.36612C8.64946 3.1317 8.33152 3 8 3C7.66848 3 7.35054 3.1317 7.11612 3.36612C6.8817 3.60054 6.75 3.91848 6.75 4.25C6.75 4.58152 6.8817 4.89946 7.11612 5.13388C7.35054 5.3683 7.66848 5.5 8 5.5C8.33152 5.5 8.64946 5.3683 8.88388 5.13388C9.1183 4.89946 9.25 4.58152 9.25 4.25Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 9.25C4.875 8.91848 4.7433 8.60054 4.50888 8.36612C4.27446 8.1317 3.95652 8 3.625 8C3.29348 8 2.97554 8.1317 2.74112 8.36612C2.5067 8.60054 2.375 8.91848 2.375 9.25C2.375 9.58152 2.5067 9.89946 2.74112 10.1339C2.97554 10.3683 3.29348 10.5 3.625 10.5C3.95652 10.5 4.27446 10.3683 4.50888 10.1339C4.7433 9.89946 4.875 9.58152 4.875 9.25Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 9.25C13.625 8.91848 13.4933 8.60054 13.2589 8.36612C13.0245 8.1317 12.7065 8 12.375 8C12.0435 8 11.7255 8.1317 11.4911 8.36612C11.2567 8.60054 11.125 8.91848 11.125 9.25C11.125 9.58152 11.2567 9.89946 11.4911 10.1339C11.7255 10.3683 12.0435 10.5 12.375 10.5C12.7065 10.5 13.0245 10.3683 13.2589 10.1339C13.4933 9.89946 13.625 9.58152 13.625 9.25Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.75C9.25 11.4185 9.1183 11.1005 8.88388 10.8661C8.64946 10.6317 8.33152 10.5 8 10.5C7.66848 10.5 7.35054 10.6317 7.11612 10.8661C6.8817 11.1005 6.75 11.4185 6.75 11.75C6.75 12.0815 6.8817 12.3995 7.11612 12.6339C7.35054 12.8683 7.66848 13 8 13C8.33152 13 8.64946 12.8683 8.88388 12.6339C9.1183 12.3995 9.25 12.0815 9.25 11.75Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5V10.5",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44751 8.30994L7.17751 5.18994",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5525 8.31003L8.82373 5.19128",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_3728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiderweb);
export default __webpack_public_path__ + "static/media/spiderweb.5c212cfcac3badbbb3dede1e2fea3427.svg";
export { ForwardRef as ReactComponent };